import {
  ContentPortalProps,
  createContentPortal,
} from "../../lib/create-content-portal";

const app = createContentPortal("AppTopRightMenuContentContainer");
const page = createContentPortal("PageTopRightMenuContentContainer");

const AppTopRightContentContainerPortal: React.FC<ContentPortalProps> = ({
  children,
  display,
}) => {
  return (
    <>
      <app.ContentPortal display={display}>{children}</app.ContentPortal>
      <page.ContentPortal display={display}>{children}</page.ContentPortal>
    </>
  );
};

export const AppTopRightMenu = {
  TopBarContentContainer: app.ContentContainer,
  PageContentContainer: page.ContentContainer,
  ContentPortal: AppTopRightContentContainerPortal,
};
